import { PillVariant } from "../../widget";
import { ProjectStatusConstants } from "../status";

export enum ProjectPhase {
  feasibility = "feasibility",
  design = "design",
  implementation = "implementation",
  ongoingMonitoring = "ongoingMonitoring",
}

const normaliseProjectPhaseValue = (value: string): string => value.toLowerCase().replace(/[^a-z]/g, "");

const PROJECT_PHASE_LABEL_MAP: Record<ProjectPhase, string> = {
  [ProjectPhase.feasibility]: "Feasibility",
  [ProjectPhase.design]: "Design",
  [ProjectPhase.implementation]: "Implementation",
  [ProjectPhase.ongoingMonitoring]: "Ongoing Monitoring",
};

export const parseProjectPhase = (value: string | null | undefined): ProjectPhase | undefined => {
  if (!value) return undefined;

  const normalisedValue = normaliseProjectPhaseValue(value);
  return Object.values(ProjectPhase).find((phase) => normaliseProjectPhaseValue(phase) === normalisedValue);
};

export const getProjectPhaseLabel = (value: string | null | undefined): string => {
  const parsedProjectPhase = parseProjectPhase(value);

  if (parsedProjectPhase) {
    return PROJECT_PHASE_LABEL_MAP[parsedProjectPhase];
  }

  return value ?? "";
};

export const PROJECT_PHASE_PILL_VARIANT_MAP: { [key: string]: PillVariant } = {
  [PROJECT_PHASE_LABEL_MAP[ProjectPhase.feasibility]]: "blue",
  [PROJECT_PHASE_LABEL_MAP[ProjectPhase.design]]: "coral",
  [PROJECT_PHASE_LABEL_MAP[ProjectPhase.implementation]]: "cyan",
  [PROJECT_PHASE_LABEL_MAP[ProjectPhase.ongoingMonitoring]]: "green",
};

export const ValidProjectStatusProjectPhases = {
  [ProjectPhase.feasibility]: [
    ProjectStatusConstants.DRAFT,
    ProjectStatusConstants.PRE_DEVELOPMENT,
    ProjectStatusConstants.UNDER_DEVELOPMENT,
    ProjectStatusConstants.VALIDATION_PENDING,
    ProjectStatusConstants.VALIDATED,
    ProjectStatusConstants.VERIFICATION_PENDING,
    ProjectStatusConstants.VERIFIED,
    ProjectStatusConstants.ONGOING_VERIFICATION,
    ProjectStatusConstants.SETUP_IN_PROGRESS,
    ProjectStatusConstants.NOT_DELIVERED,
    ProjectStatusConstants.CANCELLED,
  ],
  [ProjectPhase.design]: [
    ProjectStatusConstants.UNDER_DEVELOPMENT,
    ProjectStatusConstants.VALIDATION_PENDING,
    ProjectStatusConstants.VALIDATED,
    ProjectStatusConstants.VERIFICATION_PENDING,
    ProjectStatusConstants.VERIFIED,
    ProjectStatusConstants.ONGOING_VERIFICATION,
    ProjectStatusConstants.SETUP_IN_PROGRESS,
    ProjectStatusConstants.NOT_DELIVERED,
    ProjectStatusConstants.CANCELLED,
  ],
  [ProjectPhase.implementation]: [
    ProjectStatusConstants.VALIDATION_PENDING,
    ProjectStatusConstants.VALIDATED,
    ProjectStatusConstants.VERIFICATION_PENDING,
    ProjectStatusConstants.VERIFIED,
    ProjectStatusConstants.ONGOING_VERIFICATION,
    ProjectStatusConstants.SETUP_IN_PROGRESS,
    ProjectStatusConstants.NOT_DELIVERED,
    ProjectStatusConstants.CANCELLED,
  ],
  [ProjectPhase.ongoingMonitoring]: [
    ProjectStatusConstants.VERIFIED,
    ProjectStatusConstants.ONGOING_VERIFICATION,
    ProjectStatusConstants.SETUP_IN_PROGRESS,
    ProjectStatusConstants.NOT_DELIVERED,
    ProjectStatusConstants.CANCELLED,
  ],
};
